import { jsx } from "react/jsx-runtime";
import { Box } from "../../Box/Box.mjs";
import { useIcon } from "../../../hooks/useIcon/index.mjs";
import { IconSpaceDashboardSvg } from "./IconSpaceDashboardSvg.mjs";
const IconSpaceDashboard = (props) => {
  const iconProps = useIcon(props);
  return /* @__PURE__ */ jsx(Box, { component: IconSpaceDashboardSvg, ...iconProps });
};
export {
  IconSpaceDashboard
};
